import { createApp } from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import App from './App.vue';
import { AUTH } from './modules/Auth/store/mutation-types';
import i18n from './plugins/i18n';
import { store } from './plugins/store';
import router from './router';
import './theme/variable.css';
import Popper from 'vue3-popper';
import { useAccordion } from 'vue3-rich-accordion';
import { msalInstance } from '@/authenticationConfig';
import { msalPlugin } from '@/plugins/msalPlugin';
import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';

declare global {
    interface Window {
        CONFIG: {
            api: { baseUrl: string; apiSubscriptionKey: string };
            external: { noe3Url: string; noeEcoEnergieUrl: string};
            env: string;
            logosUrl: string;
            imagesCommunications: string;
            actualitesCommunications: string;
            auth: {
                clientId: string;
                authority: string;
                connexionB2C: string;
                connexionGH: string;
                knownAuthorities: string[];
                redirectUriWeb: string;
                postLogoutRedirectUriWeb: string;
                scope: string;
            };
            droit: {
                admin: string;
            };
        };
        'ideta_bot_action': any;
    }
}

const app = createApp(App).use(store).use(i18n).use(useAccordion).use(router).use(msalPlugin, msalInstance).use(VueSidebarMenu);
app.component('Popper', Popper);
app.component('apexchart', VueApexCharts);

router.isReady().then(() => {
    store.commit(AUTH.SET_TOKEN, localStorage.getItem('token_portail_partenaire'));
    localStorage.setItem('nom_environnement', window.CONFIG.env);
    const env = window.CONFIG?.env;
    if (env && env.toLowerCase() !== 'prod') {
        document.title = `[${env.toUpperCase()}] Portail partenaire`;
    }
    app.mount('#app');
});
